import { IWhiteLabel } from '@efex-services/auth/types';

export const ORGANIZATION_ID = 'organizationID';
export const ORGANIZATION_LOG_URL = 'organizationLogoURL';
export const PROVIDER_CODE = 'providerCode';
export const ACTION = 'action';
export const FINKARGO = 'finkargo';

export const WHITE_LABEL_DATA: IWhiteLabel = {
  organizationID: 'White Label',
  organizationLogoURL: undefined,
};
